export default __webpack_public_path__ + "static/media/step-1-fr.504b95fa.svg";